<template>
  <div class="body flex ai_c">
    <div class="w40">
      <div class="plate_title">
        <div class="plate_title_name">直播助手</div>
      </div>
      <div v-loading="loading0" class="chat_box">
        <div class="chat_body" id="chatList">
          <div class="cell" v-for="(item, index) in chatList" :key="index">
            <div class="head">
              <img
                @click="showMemberInfo(item.userId)"
                class="avatar can"
                :src="item.avatar"
                alt=""
              />
              <div class="w100">
                <div class="flex ai_c">
                  <span
                    @click="showMemberInfo(item.userId)"
                    class="nickname hang1 can"
                  >
                    {{ item.name }}
                  </span>
                  <img
                    v-if="item.level.moneyLevel > 1"
                    class="identity_level"
                    :src="item.level.moneyLevelImage"
                    alt=""
                  />
                  <img
                    class="identity_level"
                    :src="item.level.levelImage"
                    alt=""
                  />
                </div>
                <span class="time">
                  {{ item.createtime_text }}
                </span>
              </div>
            </div>
            <div class="content" v-html="item.content"></div>
          </div>
        </div>
        <!-- <chat :chat-list="chatList"></chat> -->
      </div>
    </div>
    <div class="w60">
      <div class="cell_box">
        <div class="plate_title">
          <div class="plate_title_name">游客数量统计折线图</div>
        </div>
        <div class="condition_cell">
          <div class="fz14">日期：</div>
          <el-date-picker
            @change="getChatRoomStatistics1"
            style="width: 150px"
            v-model="date1"
            size="middle"
            type="date"
            placeholder="请选择日期"
            value-format="YYYY-MM-DD"
            :clearable="false"
          />
        </div>
        <div id="echarts_line1"></div>
      </div>

      <div class="cell_box">
        <div class="plate_title">
          <div class="plate_title_name">游客列表({{ touristList.length }})</div>
        </div>
        <div
          v-loading="loading2"
          class="tourist_cells overflow_y"
          id="touristList"
        >
          <div
            class="tourist_cell"
            v-for="(item, index) in touristList"
            :key="index"
          >
            <div>{{ item.nickname }}</div>
            <div>加入时间：{{ item.createtime_text }}</div>
          </div>
        </div>
      </div>

      <div class="cell_box">
        <div class="plate_title">
          <div class="plate_title_name">在线用户数量统计折线图</div>
        </div>
        <div class="condition_cell">
          <div class="fz14">日期：</div>
          <el-date-picker
            @change="getChatRoomStatistics3"
            style="width: 150px"
            v-model="date3"
            size="middle"
            type="date"
            placeholder="请选择日期"
            value-format="YYYY-MM-DD"
            :clearable="false"
          />
        </div>
        <div id="echarts_line3"></div>
      </div>

      <div class="cell_box">
        <div class="plate_title">
          <div class="plate_title_name">
            在线用户列表({{ userList.length }})
          </div>
        </div>
        <div v-loading="loading4" class="user_cells overflow_y" id="userList">
          <div class="user_cell" v-for="(item, index) in userList" :key="index">
            <img class="user_avatar" :src="item.avatar" alt="" />

            <div>
              <div class="flex ai_c">
                <div>{{ item.nickname }}</div>
                <img
                  v-if="item.moneyLevelImage"
                  class="identity_level"
                  :src="item.moneyLevelImage"
                  alt=""
                />
                <img
                  v-if="item.levelImage"
                  class="identity_level"
                  :src="item.levelImage"
                  alt=""
                />
              </div>
              <div class="fz12">加入时间：{{ item.join_time }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 用户信息 -->
    <el-dialog
      title="用户信息"
      v-model="memberInfoDialogStatus"
      width="600px"
      @close="memberInfoDialogStatus = false"
    >
      <div>
        <div class="userinfo_popup_member">
          <div class="pr mr10">
            <img class="userinfo_avatar" :src="memberInfo.avatar" alt="" />
          </div>
          <div class="infos">
            <div class="flex ai_c">
              <div class="userinfo_nickname">{{ memberInfo.nickname }}</div>
            </div>
            <div class="identity">
              <img
                v-if="memberInfo.level.moneyLevel > 1"
                class="identity_img"
                :src="memberInfo.level.moneyLevelImage"
                alt=""
              />
              <img
                class="identity_img"
                :src="memberInfo.level.levelImage"
                alt=""
              />
            </div>
            <div class="expiration_time">
              到期时间：{{ memberInfo.level.levelExpirationTime }}
            </div>
          </div>
        </div>
        <div>
          <el-table
            :data="memberInfo.offerInfo.allAsset"
            border
            style="width: 100%"
          >
            <el-table-column prop="company_name" label="期货公司" width="110" />
            <el-table-column prop="name" label="实盘名称" width="90" />
            <el-table-column prop="asset" label="资产账号" width="120" />
            <el-table-column
              prop="last_money_end"
              label="期末权益"
              width="120"
            />
            <el-table-column prop="add_fee" label="加收手续费" />
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import request from "@/utils/request";
import { emojiReplace, formatTime } from "@/utils/common";
export default {
  data() {
    return {
      chatList: [],
      room_id: 1,
      loading0: false,
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      size: "medium",
      varietiesList: [], //品种列表
      teacherList: [], //研究员列表
      tableData: [],
      loadingTable: false,
      page: 1,
      total: 1,
      pageSize: 15,

      repeatCount: 0,

      teacher_id: 0, // 当前在麦研究员类型
      live_status: null,

      postList: [], // 海报列表
      postStatus: false, // 海报显示状态
      postIndex: null,

      memberInfoDialogStatus: false,
      memberInfo: {},
      touristList: [], // 游客列表
      userList: [],
      timer: null,
      date1: "",
      date3: "",
    };
  },
  unmounted() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    window.onmessageSocket = this.onmessage;
    this.getRoomChatList(Math.round(new Date() / 1000));
    this.date1 = formatTime(Math.round(new Date() / 1000), "Y-M-D");
    this.date3 = formatTime(Math.round(new Date() / 1000), "Y-M-D");
    this.getVisitorCustomerList();
    this.getOnLineChatRoomList();
    this.getChatRoomStatistics1();
    this.getChatRoomStatistics3();

    this.timer = setInterval(() => {
      this.getVisitorCustomerList();
      this.getOnLineChatRoomList();
      this.getChatRoomStatistics1();
      this.getChatRoomStatistics3();
    }, 1000 * 30);

    // this.echartsLine1();
  },
  methods: {
    onmessage(e) {
      const redata = JSON.parse(e.data);
      // console.log("index-redata", redata);
      var chatList = this.chatList;
      switch (redata.type) {
        // 直播间有用户发消息
        case "chat_room_accept":
          chatList.push({
            userId: redata.user_info.id,
            name: redata.user_info.nickname,
            avatar: redata.user_info.avatar,
            content: emojiReplace(redata.content),
            createtime_text: redata.createtime_text,
            level: redata.user_info.level,
          });
          this.scoll0();
          break;
        //直播间状态变更
        case "live_status":
          this.$notify({
            title: "提示",
            message: "直播间状态已更改",
            duration: 3000,
          });
          this.getRoomInfo();
          break;
        //直播间删除某条信息
        case "room_chat_delete":
          // console.log("删除之前", chatList);
          for (const [index, item] of chatList.entries()) {
            if (item.id == redata.content.id) {
              chatList.splice(index, 1);
            }
          }
          this.chatList = chatList;
          break;
      }
    },
    async getChatRoomStatistics1() {
      const res = await request.post(
        "/teacher/statistics/getChatRoomStatistics",
        {
          date: this.date1,
          type: 2,
        }
      );
      this.echartsLine1(res.data);
    },
    async getChatRoomStatistics3() {
      const res = await request.post(
        "/teacher/statistics/getChatRoomStatistics",
        {
          date: this.date3,
          type: 1,
        }
      );
      this.echartsLine3(res.data);
    },
    echartsLine1(data) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById("echarts_line1"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "",
          left: "0",
          textStyle: {
            color: "#1A1A1A",
            fontSize: 16,
          },
        },
        tooltip: {
          confine: true,
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,0.6)",
          textStyle: {
            color: "#fff",
          },
          axisPointer: {
            type: "cross",
          },
          // formatter(params) {
          //   // console.log('params', params)
          //   let str = `${params[0].name}<br />`;
          //   for (const item of params) {
          //     const data = item.data;
          //     if (data) {
          //       let dataVal = null;
          //       let marker = "";
          //       switch (item.seriesIndex) {
          //         case 0:
          //           marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;box-sizing: border-box;border: 1px solid ${"#F00000"};background-color:${"#F00000"};"></span>`;
          //           dataVal = data;
          //           break;
          //         case 1:
          //           marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;box-sizing: border-box;border: 1px dashed ${"#12C05E"};background-color:${"#12C05E"};"></span>`;
          //           dataVal = data;
          //           break;
          //         case 2:
          //           marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;box-sizing: border-box;border: 1px dashed ${"#5D45E7"};background-color:${"#5D45E7"};"></span>`;
          //           dataVal = data;
          //           break;
          //       }
          //       str += `${marker + item.seriesName}：${dataVal}<br />`;
          //     }
          //   }
          //   return str;
          // },
        },
        // legend: {
        //   data: ["PC", "安卓", "IOS"],
        //   top: 0,
        //   x: "center",
        // },
        grid: {
          top: 50,
          left: 70,
          right: 20,
          bottom: 30,
        },
        // 目前数据统计图表的时间范围为60天，取30天
        // dataZoom: [
        //   {
        //     type: "inside",
        //     start: 0,
        //     end: 100,
        //   },
        //   {
        //     show: true,
        //     type: "slider",
        //     bottom: "10px",
        //     start: 0,
        //     end: 100,
        //   },
        // ],
        xAxis: {
          type: "category",
          boundaryGap: true,
          // data: [
          //   "2022-07-04",
          //   "2022-07-05",
          //   "2022-07-06",
          //   "2022-07-07",
          //   "2022-07-08",
          // ],
          data: data.dataX,
          scale: true, // 是否是脱离 0 值比例。设置成 true 后坐标刻度不会强制包含零刻度
          axisLine: {
            // x轴
            show: true,
          },
          axisTick: {
            // x轴刻度线
            show: false,
          },
          axisLabel: {
            color: "#707070",
            fontSize: 10,
          },
        },
        yAxis: [
          {
            type: "value",
            name: "人",
            scale: true, // 是否是脱离 0 值比例。设置成 true 后坐标刻度不会强制包含零刻度
            nameLocation: "end",
            nameTextStyle: {
              color: "#1A1A1A",
              fontSize: 14,
              align: "right",
            },
            axisLine: {
              // y轴线
              show: false,
            },
            axisTick: {
              // y轴刻度
              show: false,
            },
            axisLabel: {
              // show :false,
              color: "#707070",
            },
            splitLine: {
              lineStyle: {
                color: "#ECECEC",
                width: 1,
                type: "solid",
              },
            },
          },
        ],
        series: [
          {
            color: "#F00000",
            name: "在线人数",
            type: "line",
            smooth: true,
            // data: [3814, 3757, 2067, 2028, 2091],
            data: data.dataY,
            showSymbol: true, // 拐点tooltip hover时候才显示出来
          },
          // {
          //   color: "#12C05E",
          //   name: "安卓",
          //   type: "line",
          //   smooth: true,
          //   data: [3714, 3657, 1967, 1928, 1991],
          //   showSymbol: true, // 拐点tooltip hover时候才显示出来
          // },
          // {
          //   color: "#5D45E7",
          //   name: "IOS",
          //   type: "line",
          //   smooth: true,
          //   data: [3614, 3557, 1867, 1828, 1891],
          //   showSymbol: true, // 拐点tooltip hover时候才显示出来
          // },
        ],
      });
    },
    echartsLine3(data) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById("echarts_line3"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "",
          left: "0",
          textStyle: {
            color: "#1A1A1A",
            fontSize: 16,
          },
        },
        tooltip: {
          confine: true,
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,0.6)",
          textStyle: {
            color: "#fff",
          },
          axisPointer: {
            type: "cross",
          },
          // formatter(params) {
          //   // console.log('params', params)
          //   let str = `${params[0].name}<br />`;
          //   for (const item of params) {
          //     const data = item.data;
          //     if (data) {
          //       let dataVal = null;
          //       let marker = "";
          //       switch (item.seriesIndex) {
          //         case 0:
          //           marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;box-sizing: border-box;border: 1px solid ${"#F00000"};background-color:${"#F00000"};"></span>`;
          //           dataVal = data;
          //           break;
          //         case 1:
          //           marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;box-sizing: border-box;border: 1px dashed ${"#12C05E"};background-color:${"#12C05E"};"></span>`;
          //           dataVal = data;
          //           break;
          //         case 2:
          //           marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;box-sizing: border-box;border: 1px dashed ${"#5D45E7"};background-color:${"#5D45E7"};"></span>`;
          //           dataVal = data;
          //           break;
          //       }
          //       str += `${marker + item.seriesName}：${dataVal}<br />`;
          //     }
          //   }
          //   return str;
          // },
        },
        // legend: {
        //   data: ["PC", "安卓", "IOS"],
        //   top: 0,
        //   x: "center",
        // },
        grid: {
          top: 50,
          left: 70,
          right: 20,
          bottom: 30,
        },
        // 目前数据统计图表的时间范围为60天，取30天
        // dataZoom: [
        //   {
        //     type: "inside",
        //     start: 0,
        //     end: 100,
        //   },
        //   {
        //     show: true,
        //     type: "slider",
        //     bottom: "10px",
        //     start: 0,
        //     end: 100,
        //   },
        // ],
        xAxis: {
          type: "category",
          boundaryGap: true,
          // data: [
          //   "2022-07-04",
          //   "2022-07-05",
          //   "2022-07-06",
          //   "2022-07-07",
          //   "2022-07-08",
          // ],
          data: data.dataX,
          scale: true, // 是否是脱离 0 值比例。设置成 true 后坐标刻度不会强制包含零刻度
          axisLine: {
            // x轴
            show: true,
          },
          axisTick: {
            // x轴刻度线
            show: false,
          },
          axisLabel: {
            color: "#707070",
            fontSize: 10,
          },
        },
        yAxis: [
          {
            type: "value",
            name: "人",
            scale: true, // 是否是脱离 0 值比例。设置成 true 后坐标刻度不会强制包含零刻度
            nameLocation: "end",
            nameTextStyle: {
              color: "#1A1A1A",
              fontSize: 14,
              align: "right",
            },
            axisLine: {
              // y轴线
              show: false,
            },
            axisTick: {
              // y轴刻度
              show: false,
            },
            axisLabel: {
              // show :false,
              color: "#707070",
            },
            splitLine: {
              lineStyle: {
                color: "#ECECEC",
                width: 1,
                type: "solid",
              },
            },
          },
        ],
        series: [
          {
            color: "#F00000",
            name: "在线人数",
            type: "line",
            smooth: true,
            // data: [3814, 3757, 2067, 2028, 2091],
            data: data.dataY,
            showSymbol: true, // 拐点tooltip hover时候才显示出来
          },
          // {
          //   color: "#12C05E",
          //   name: "安卓",
          //   type: "line",
          //   smooth: true,
          //   data: [3714, 3657, 1967, 1928, 1991],
          //   showSymbol: true, // 拐点tooltip hover时候才显示出来
          // },
          // {
          //   color: "#5D45E7",
          //   name: "IOS",
          //   type: "line",
          //   smooth: true,
          //   data: [3614, 3557, 1867, 1828, 1891],
          //   showSymbol: true, // 拐点tooltip hover时候才显示出来
          // },
        ],
      });
    },
    async showMemberInfo(id) {
      const res = await request.post("/teacher/customer/getUserInfo", {
        id,
      });
      this.memberInfo = res.data;
      this.memberInfoDialogStatus = true;
    },
    async getVisitorCustomerList() {
      this.loading2 = true;
      const res = await request.post(
        "/teacher/customer/getvisitorCustomerList"
      );
      this.touristList = res.data.reverse();
      setTimeout(() => {
        this.loading2 = false;
      }, 100);
      this.scoll2();
    },
    async getOnLineChatRoomList() {
      this.loading4 = true;
      const res = await request.post("/teacher/customer/getOnLineChatRoomList");
      this.userList = res.data;
      setTimeout(() => {
        this.loading4 = false;
      }, 100);
      this.scoll4();
    },
    //获取历史消息
    async getRoomChatList(createtime) {
      this.loading0 = true;
      let that = this;
      const res = await request.post("/api/chat/getRoomChatList", {
        room_id: that.room_id,
        createtime: createtime,
      });
      console.log("getRoomChatList", res);
      var chatList = that.chatList;
      for (const item of res.data.list) {
        chatList.unshift({
          id: item.id,
          userId: item.user.id,
          name: item.user.nickname,
          avatar: item.user.avatar,
          content: emojiReplace(item.content),
          createtime_text: item.createtime_text,
          level: item.user.level,
        });
      }
      that.chatList = chatList;
      that.scoll0();
      this.loading0 = false;
    },
    scoll0() {
      $("#chatList").animate(
        {
          scrollTop: "99999px",
        },
        1000
      );
    },
    scoll2() {
      $("#touristList").animate(
        {
          scrollTop: "99999px",
        },
        1000
      );
    },
    scoll4() {
      $("#userList").animate(
        {
          scrollTop: "99999px",
        },
        1000
      );
    },
    // 获取直播间信息
    async getRoomInfo() {
      const res = await request.post("/teacher/chat/getRoomInfo");
      console.log("获取直播间信息", res);
      this.live_status = res.data.roomInfo.live_status;
      this.teacher_id = res.data.roomInfo.teacher_id;
    },
  },
};
</script>

<style scoped>
.body {
  height: 100vh;
}

.w40 {
  height: 100%;
  border-right: 1px solid #ebeced;
}

.h400 {
  height: 400px;
}

.w60 {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}

.cell_box {
  width: 50%;
  height: 50%;
  box-sizing: border-box;
}

.cell_box:nth-child(1) {
  border-right: 1px solid #ebeced;
  /* border-bottom: 1px solid #ebeced; */
}

.cell_box:nth-child(2) {
  /* border-bottom: 1px solid #ebeced; */
}

.cell_box:nth-child(3) {
  border-right: 1px solid #ebeced;
}

.cell_box:nth-child(4) {
}

.plate_title {
  background-color: #f8fcff;
  font-size: 16px;
  font-weight: 500;
  box-sizing: border-box;
  /* padding: 18px 0; */
  border-top: 1px solid #ebeced;
  border-bottom: 1px solid #ebeced;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  padding-right: 25px;
}

.plate_title_name {
  position: relative;
  line-height: 16px;
  padding-left: 30px;
}

.plate_title_name::before {
  content: "";
  position: absolute;
  left: 13px;
  width: 4px;
  height: 16px;
  background-color: #5389f5;
  border-radius: 5px;
}

/deep/.el-input-number--large {
  width: 112px;
}

/deep/.el-divider--horizontal {
  width: 30px;
  margin: 0 8px;
}

.chat_box {
  width: 100%;
  height: calc(100% - 54px);
}

.scoll {
  line-height: 16px;
  margin-right: 30px;
  cursor: pointer;
}

/* ********************************** */
.chat_body {
  box-sizing: border-box;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.chat_body::-webkit-scrollbar {
  display: block;
  width: 4px;
  /*height: 6px;*/
}

.chat_body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px #aaa;
  background: rgba(0, 0, 0, 0.6);
}

.chat_body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px #aaa;
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.cell {
  margin-bottom: 20px;
}

.head {
  display: flex;
  align-items: center;
}

.avatar {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid #e7e7e7;
  box-sizing: border-box;
  margin-right: 10px;
}

.nickname {
  font-size: 14px;
  color: #4571e7;
  max-width: 130px;
}

.identity_level {
  height: 18px;
  display: block;
  margin-left: 6px;
}

.time {
  font-size: 12px;
  color: #8590a6;
}

.content {
  box-sizing: border-box;
  padding: 5px 0 0 40px;
}

.content >>> img {
  width: 200px;
}

#elementID {
  position: fixed;
  right: 50px;
  bottom: 50px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  color: #fff;
  cursor: pointer;
}

.tourist_cells {
  width: 100%;
  height: calc(100% - 54px);
  box-sizing: border-box;
  border-left: 1px solid #ebeced;
}

.tourist_cell {
  box-sizing: border-box;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}

.user_cells {
  width: 100%;
  height: calc(100% - 54px);
  box-sizing: border-box;
  border-left: 1px solid #ebeced;
}

.user_cell {
  box-sizing: border-box;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.user_avatar {
  width: 36px;
  height: 36px;
  display: block;
  margin-right: 4px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid #e7e7e7;
  box-sizing: border-box;
}

.condition_cell {
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
}

#echarts_line1,
#echarts_line3 {
  width: 100%;
  height: calc(100% - 54px - 54px);
}

.userinfo_popup_member {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 20px 10px 17px 20px;
  background: linear-gradient(225deg, #e3eeff 0%, #f3f8ff 100%);
}

.userinfo_popup_member .userinfo_avatar {
  width: 44px;
  height: 44px;
  object-fit: cover;
  flex-shrink: 0;
  display: block;
  border-radius: 50%;
  border: 1px solid #dedede;
}

.userinfo_popup_member .infos {
}

.userinfo_popup_member .infos .userinfo_nickname {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  word-break: break-all;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  max-width: 120px;
}

.userinfo_popup_member .infos .identity {
  margin-top: 4px;
  display: flex;
  align-items: center;
  column-gap: 8px;
}

.userinfo_popup_member .infos .identity_img {
  height: 29px;
  display: block;
}

.userinfo_popup_member .expiration_time {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  margin-top: 8px;
}
</style>
